export default __webpack_public_path__ + "static/media/visa.78d14c84.svg";